module.exports = __webpack_public_path__ + "static/media/covi_per_loc_ent.ffbdf3d0.png";